<template>
  <div>
    <Header />
    <div class="pt80">
      <div id="section1">
        <div class="container">
          <div class="th">
            <span>{{ $t("header.nav3") }}</span>
            <i class="el-icon-arrow-right"></i>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="th2">{{ $t("tool.th") }}</div>
          <div class="txt">
            {{ $t("tool.tips") }}
          </div>
        </div>
      </div>

      <div id="section2">
        <div class="container">
          <div class="d-flex">
            <div class="items">
              <div class="item" v-for="i in 6">
                <div class="th2">
                  <svgIcon
                    className="icon"
                    :iconName="`icon-tool${i}`"
                  ></svgIcon
                  ><span>{{ $t(`tool.sec.t${i}`) }}</span>
                </div>
                <div class="tips">
                  {{ $t(`tool.sec.tips${i}`) }}
                </div>
              </div>
            </div>
            <img src="@/assets/tool-2.png" width="516px" height="100%" />
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import "@/assets/css/animate.css";
export default {
  name: "personal",
  components: { Header, Footer },
  data() {
    return {
      activeId: "#section",
      channel: this.$route.query.channel,
      httpIp: "https://naps.zxszkj.com",
      carouselIndex: 0,
      partId: "1",
      addresssId: "a1",
      address: {
        a1: { x: 127, y: 535, name: "中国总部" },
        a2: { x: 162, y: 518, name: "香港" },
        a3: { x: 188, y: 323, name: "尼日利亚" },
        a4: { x: 213, y: 391, name: "坦桑尼亚" },
        a5: { x: 109, y: 428, name: "哈萨克斯坦" },
        a6: { x: 203, y: 518, name: "新加坡" },
      },
    };
  },
  computed: {
    // ...mapGetters([
    // 'user'
    // ]),
    disabled() {
      if (this.phone && this.code && this.qq) {
        return false;
      } else {
        return true;
      }
    },
  },
  mounted() {
    localStorage.setItem("channel", this.$route.query.channel);
  },
  methods: {
    toProduct() {
      this.$router.push("/product");
    },
    openAbout() {
      window.open(`${this.httpIp}/#/about`);
    },
    openLogin() {
      this.$router.push("/login");
    },

    changeCarousel(index) {
      console.log(index);
      this.carouselIndex = index;
    },
  },
};
</script>

<style lang="less" scoped>
.pt80 {
  padding-top: 80px;
}
.container {
  padding: 0;
}

#section1 {
  height: 244px;
  background-image: url(~@/assets/tool-1.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  .th {
    margin-top: 18px;
    font-weight: 500;
    font-size: 20px;
    color: #3b3b3b;
    line-height: 20px;
    i {
      &:last-child {
        margin-left: -20px;
      }
    }
  }
  .th2 {
    margin-top: 11px;
    margin-bottom: 25px;
    font-weight: 300;
    font-size: 64px;
    color: #1485ef;
    line-height: 64px;
  }
  .txt {
    width: 537px;
    font-weight: 350;
    font-size: 16px;
    color: #888888;
    line-height: 28px;
  }
}

#section2 {
  padding: 80px 0;
  .items {
    margin-right: 50px;
    width: 450px;
    .item {
      margin-bottom: 20px;
      .th2 {
        display: flex;
        align-items: center;
        .icon {
          margin-right: 8px;
          font-size: 30px;
        }
        span {
          font-weight: 700;
          font-size: 18px;
          color: #1485ef;
          line-height: 32px;
        }
      }
      .tips {
        margin-top: 6px;
        font-weight: 350;
        font-size: 14px;
        color: #9e9e9e;
        line-height: 21px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/technology/tool.vue